/**
 * nl2brFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

nl2brFilter.$inject = ['$sce'];

export function nl2brFilter($sce) {
    return input => $sce.trustAsHtml(nl2br(input));
}

export function nl2br(input) {
    if (!input) {
        return input;
    }

    return (input + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}
